import Launchpad from "./Launchpad";

export default Launchpad;